/* v2026-07-16b — cache poke: CDN was serving a stale copy of this asset */
function generateSrcset(src) {
  // Define the desired widths for the srcset
  const widths = [165, 360, 535, 750, 1070, 1500];

  // Generate the srcset attribute with different widths
  const srcset = widths
    .map(function (width) {
      return `${src}?width=${width} ${width}w`;
    })
    .join(',');

  return srcset;
}

function updateVariantOptionsAvailability(variants, inputs, value) {
  // Reset values
  Array.from(inputs).forEach(function (input) {
    input.parentElement.style.opacity = 1;
    input.disabled = false;
    input.parentElement.classList.remove('disabled');
  });

  const unavailableVariants = variants.filter(
    (v) => v.title.includes(value) && !v.available
  );

  unavailableVariants.forEach(function (v) {
    const inputToDisabled = Array.from(inputs).find((i) => {
      return (
        v.option1 === i.value || v.option2 === i.value || v.option3 === i.value
      );
    });

    if (inputToDisabled) {
      inputToDisabled.parentElement.classList.add('disabled');
      inputToDisabled.parentElement.style.opacity = 0.5;
      inputToDisabled.disabled = true;
    }
  });
}

function submitQuickAdd(variant, elements, buttonParentElement) {
  if (!variant) {
    console.error('No variant selected for quick add');
    return;
  }
  
  buttonParentElement.classList.add('is-loading');
  const isPreOrder = buttonParentElement.dataset.isPreOrder;

  let items = [
    {
      id: variant.id,
      quantity: 1,
    },
  ];

  if (isPreOrder === 'true') {
    items = [
      {
        id: variant.id,
        quantity: 1,
        properties: {
          Note: 'Pre-Order',
        },
      },
    ];
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: items,
      sections: 'cart-icon-bubble,cart-flyout',
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        buttonParentElement.classList.remove('is-loading');
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(function (data) {
      if (elements.cartNotification) {
        elements.cartNotification.renderContents(data);
      }
      /* atari:cart:updated is fired by the global fetch intercept in
         layout/theme.liquid — no manual dispatch needed. */

      const emptyCartProductsRecommendations = document.querySelector(
        "[data-js-element='empty-product-recommendations__container']"
      );

      const cartFlyoutRecommendations = document.querySelector(
        '.js-cart-flyout__product-recommendations-ct'
      );

      const cartProductsRecommendations = document.querySelector(
        '.js-cart-recommendations'
      );

      buttonParentElement.classList.remove('is-loading');

      if (!emptyCartProductsRecommendations && !cartFlyoutRecommendations) {
        return;
      }

      if (cartFlyoutRecommendations) {
        cartFlyoutRecommendations.classList.remove('hidden');
      }
      
      if (emptyCartProductsRecommendations) {
        emptyCartProductsRecommendations.classList.add('hidden');
      }

      const product = data.items[0];

      if (!product) {
        return;
      }

      fetch(
        window.Shopify.routes.root +
        `recommendations/products?product_id=${product.product_id}&limit=4&section_id=cart-flyout&intent=related`
      )
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          const quickAdds = Array.from(html.querySelectorAll('.quick-add'));
          const quickAddColors = Array.from(
            html.querySelectorAll('.quick-add_colors')
          );

          if (quickAdds.length > 0) {
            quickAdds.forEach((el) => {
              el.classList.add('hidden');
            });
          }

          if (quickAddColors.length > 0) {
            quickAddColors.forEach((el) => {
              el.classList.add('hidden');
            });
          }

          if (recommendations && recommendations.innerHTML.trim().length && cartProductsRecommendations) {
            cartProductsRecommendations.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item') && cartProductsRecommendations) {
            cartProductsRecommendations.classList.add(
              'product-recommendations--loaded'
            );
          }
          
          // Re-initialize quick add for the new recommendations
          initQuickAdd();
        })
        .catch((e) => {
          console.error(e);
        });
    })
    .catch(function (error) {
      console.error(
        'There has been a problem with your fetch operation: ',
        error
      );
      buttonParentElement.classList.remove('is-loading');
    });
}

function initQuickAdd() {
  const elements = {
    cartNotification: document.querySelector('cart-notification'),
    quickAddButtons: Array.from(document.querySelectorAll('.quick-add')),
  };

  if (!elements.quickAddButtons || elements.quickAddButtons.length === 0) {
    return;
  }

  elements.quickAddButtons.forEach(function (button) {
    // Skip if this button has already been initialized
    if (button.getAttribute('data-initialized') === 'true') {
      return;
    }
    
    const buttonParentElement = button.closest('.quick-add-button');
    const quickAddForm = button.closest('[data-js-element="quick-add-form"]');

    if (!quickAddForm) {
      return;
    }

    const firstProductImage = quickAddForm.querySelector(
      '.pdp-first__image img'
    );

    const inputs = {
      size: Array.from(quickAddForm.querySelectorAll('input[name="Size"]')),
      color: Array.from(quickAddForm.querySelectorAll('input[name="Color"]')),
      all: Array.from(quickAddForm.querySelectorAll('input[type="radio"]')),
    };

    if (quickAddForm.classList.contains('is-unavailable')) {
      return;
    }

    let productVariants;
    try {
      productVariants = JSON.parse(quickAddForm.dataset.productVariants);
    } catch (e) {
      console.error('Error parsing product variants:', e);
      return;
    }

    // Button clicks
    quickAddForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();

      // find all checked radio input
      const checkedRadioInputs = Array.from(
        quickAddForm.querySelectorAll('input[type="radio"]:checked')
      );

      // get all checked radio input values
      const optionValues = Array.from(checkedRadioInputs).map(function (
        checkedRadioInput
      ) {
        return checkedRadioInput.value;
      });

      // find the variant that matches the selected options
      const variant = productVariants.find(function (variant) {
        return (
          (variant.title === optionValues.join(' / ') && variant.available) ||
          (variant.option1 === 'Default Title' && variant.available)
        );
      });

      if (!variant) {
        console.error('No variant found with the selected options', optionValues);
        return;
      }

      submitQuickAdd(variant, elements, buttonParentElement);
    });

    // ALL INPUTS
    inputs.all.forEach(function (radioInput) {
      radioInput.addEventListener('change', function (event) {
        // find all checked radio input
        const checkedRadioInputs = Array.from(
          quickAddForm.querySelectorAll('input[type="radio"]:checked')
        );

        // get all checked radio input values
        const optionValues = Array.from(checkedRadioInputs).map(function (
          checkedRadioInput
        ) {
          return checkedRadioInput.value;
        });

        // find the variant that matches the selected options
        const variant = productVariants.find(function (variant) {
          let optionValue;
          if (optionValues.length === 2) {
            if (
              variant.title === `${optionValues[1]} / ${optionValues[0]}` ||
              variant.title === `${optionValues[0]} / ${optionValues[1]}`
            ) {
              optionValue = true;
            }
          } else {
            optionValue = variant.title.includes(optionValues.join(' / '));
          }
          return optionValue;
        });

        if (variant && variant.featured_image && firstProductImage) {
          const src = variant.featured_image.src;
          const srcset = generateSrcset(src);
          if (srcset) {
            firstProductImage.srcset = srcset;
          }
        }
      });
    });

    // COLOR INPUTS
    inputs.color.forEach(function (radioInput) {
      if (radioInput.checked) {
        updateVariantOptionsAvailability(
          productVariants,
          inputs.all,
          radioInput.value
        );
      }

      radioInput.addEventListener('change', function (event) {
        const value = event.target.value;

        const currentVariantOptions = productVariants.filter((v) => {
          return v.title.includes(value);
        });

        const unavailableOptions = currentVariantOptions.filter(
          (variant) => variant.available === false
        );

        const availableOptions = currentVariantOptions.filter(
          (variant) => variant.available === true
        );

        if (inputs.size.length === 0) {
          return;
        }

        inputs.size.forEach((input) =>
          unavailableOptions.forEach((variant) => {
            if (variant.option1.includes(input.value)) {
              input.parentElement.classList.add('disabled');
              input.parentElement.style.opacity = 0.5;
              input.disabled = true;
            }
            availableOptions.forEach((variant) => {
              if (variant.option1.includes(input.value)) {
                input.parentElement.classList.remove('disabled');
                input.parentElement.style.opacity = 1;
                input.disabled = false;
              }
            });
          })
        );
      });
    });

    // SIZE INPUTS
    inputs.size.forEach(function (radioInput) {
      radioInput.addEventListener('change', function (event) {
        // find all checked radio input
        const checkedRadioInputs = Array.from(
          quickAddForm.querySelectorAll('input[type="radio"]:checked')
        );

        // get all checked radio input values
        const optionValues = Array.from(checkedRadioInputs).map(function (
          checkedRadioInput
        ) {
          return checkedRadioInput.value;
        });

        // find the variant that matches the selected options
        const variant = productVariants.find(function (variant) {
          let optionValue;

          if (optionValues.length === 2) {
            if (
              variant.title === `${optionValues[1]} / ${optionValues[0]}` ||
              variant.title === `${optionValues[0]} / ${optionValues[1]}`
            ) {
              optionValue = true;
            }
          } else {
            optionValue = variant.title.includes(optionValues.join(' / '));
          }
          return optionValue;
        });

        // add to cart
        if (variant) {
          submitQuickAdd(variant, elements, buttonParentElement);
        }
      });
    });
    
    // Mark as initialized
    button.setAttribute('data-initialized', 'true');
  });
}

// Initialize on page load
window.addEventListener('load', initQuickAdd);

// Re-initialize when filters are activated
document.addEventListener('filters-activated', (e) => {
  initQuickAdd();
});

// Re-initialize when predictive search results are updated
document.addEventListener('predictive-search:updated', () => {
  setTimeout(initQuickAdd, 100); // Slight delay to ensure DOM is updated
});

// Listen for when predictive search renders new content
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && 
          (mutation.target.id === 'predictive-search-results' || 
           mutation.target.closest('#predictive-search-results'))) {
        initQuickAdd();
      }
    });
  });

  // Start observing the document body for DOM changes
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
});


/* Card swatch image swap (2026-07-16). The original swap lived inside
   initQuickAdd and has been dead since quick-add buttons were disabled and
   data-product-variants was removed for perf (17.5KB/card). This standalone
   delegated listener replaces it: each color radio carries its variant image
   via a server-rendered data-img attribute (see quick-add-colors.liquid) —
   no per-card variant JSON required. */
document.addEventListener('change', function cardSwatchImageSwap(e) {
  var input = e.target;
  if (!input || input.name !== 'Color' || input.type !== 'radio') return;
  var form = input.closest('.quick-add-form');
  if (!form) return;
  var src = input.getAttribute('data-img');
  if (!src) return;
  var img = form.querySelector('.pdp-first__image img');
  if (!img) return;
  img.srcset = generateSrcset(src);
  img.src = src + '?width=535';
});
